module.exports = __webpack_public_path__ + "media/images/lb/288-25acdf8b4a133f84065dd87ad47ba59a.svg";